import { useContext } from 'react'
import { ReactReduxContext } from 'react-redux'

// Some cells render without a Redux Provider (tests, stories), so read the store through the context.
export const useScreenshotMode = (screenshotMode?: boolean): boolean => {
    const reduxContext = useContext(ReactReduxContext)
    const globalScreenshotMode = reduxContext?.store.getState().user?.screenshot_mode ?? false
    return Boolean(screenshotMode) || globalScreenshotMode
}
